import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface DeleteFlashMessageResponse extends MiddlewareAPIResponse
{
    // getFlashMessageResponseDtos(): FlashMessageDto[];
}

export class DeleteFlashMessageResponseDtoImpl extends MiddlewareDtoImpl implements DeleteFlashMessageResponse
{
    // private getFlashMessageDto : FlashMessageDto[];

    // getFlashMessageResponseDtos(): FlashMessageDto[]
    // {
    //     return this.getFlashMessageDto;
    // }

    // setFlashMessageResponseDtos(getFlashMessageDto: FlashMessageDto[])
    // {
    //     this.getFlashMessageDto = getFlashMessageDto;
    // }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/delete/deleteflashmessagesresponse.tsx